import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function ConfirmDeleteModal({
    opened,
    onClose,
    onConfirm,
    loading,
    entityName,
}: {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
    entityName: string;
}) {
    const { t } = useTranslation();

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={t('common.delete.confirmTitle', { entity: entityName })}
            closeOnClickOutside={!loading}
            closeOnEscape={!loading}
        >
            <Stack gap="md">
                <Text size="sm">{t('common.delete.confirmMessage')}</Text>
                <Group justify="flex-end">
                    <Button variant="default" onClick={onClose} disabled={loading}>
                        {t('common.actions.cancel')}
                    </Button>
                    <Button color="red" onClick={onConfirm} loading={loading}>
                        {t('common.actions.remove')}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
}
